import { useSelector } from 'react-redux';

import { newList } from 'features/lists/helpers';

import * as Types from 'types';

export const useList = <T extends Types.Identifiable>(
  listId: string,
  objectByIdSelector: (state: Types.RootState) => Record<string, T>,
) => {
  const listsById = useSelector((state: Types.RootState) => state.lists.byId);
  const objectsById = useSelector<Types.RootState, Record<string, T>>(
    objectByIdSelector,
  );
  const list = listsById[listId];

  if (!list) {
    return newList(listId);
  }

  if (!objectByIdSelector) {
    return list;
  }

  const objects = list.ids.map((id) => {
    return objectsById[id];
  });

  const listWithObjects = {
    ...list,
    objects,
  };

  return listWithObjects;
};
